import { render, staticRenderFns } from "./client-gnb.vue?vue&type=template&id=96dad800&"
import script from "./client-gnb.vue?vue&type=script&lang=js&"
export * from "./client-gnb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports